var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlooding(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 61,
    height: 54,
    viewBox: "0 0 61 54",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 33.0728C4.98943 33.0728 4.98943 35.6098 10 35.6098C15.0106 35.6098 14.9894 33.0728 20 33.0728C25.0106 33.0728 24.9894 35.6098 30 35.6098C35.0106 35.6098 34.9894 33.0728 40 33.0728C45.0106 33.0728 44.9894 35.6098 50 35.6098C55.0106 35.6098 54.9894 33.0728 60 33.0728",
    stroke: "#005FC8",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 24.4014C4.98943 24.4014 4.98943 26.9384 10 26.9384C15.0106 26.9384 14.9894 24.4014 20 24.4014C25.0106 24.4014 24.9894 26.9384 30 26.9384C35.0106 26.9384 34.9894 24.4014 40 24.4014C45.0106 24.4014 44.9894 26.9384 50 26.9384C55.0106 26.9384 54.9894 24.4014 60 24.4014",
    stroke: "#005FC8",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 41.74C4.98943 41.74 4.98943 44.277 10 44.277C15.0106 44.277 14.9894 41.74 20 41.74C25.0106 41.74 24.9894 44.277 30 44.277C35.0106 44.277 34.9894 41.74 40 41.74C45.0106 41.74 44.9894 44.277 50 44.277C55.0106 44.277 54.9894 41.74 60 41.74",
    stroke: "#005FC8",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M60 16.2627V52.3092H0V16.2627",
    stroke: "#005FC8",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.873 9.37109L19.8773 15.4176L25.9238 9.37109",
    stroke: "#005FC8",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.877 0.0266113V15.2063",
    stroke: "#005FC8",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M33.957 9.37109L39.9613 15.4176L46.0078 9.37109",
    stroke: "#005FC8",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M39.9609 0.0266113V15.2063",
    stroke: "#005FC8",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlooding);
export default __webpack_public_path__ + "static/media/flooding.ed391113.svg";
export { ForwardRef as ReactComponent };